export const CHAT_GROUP_DAY_RANGES = {
  PREV_7_DAYS: 7,
  PREV_30_DAYS: 30,
};
